import { Box } from "@mui/material"
import { CenteredBox } from "./boxes"
import LogoImage from './../../../assets/images/WEHEARRMS.png'
const Logo = ({...rest}) => {
    return <CenteredBox  {...rest}>
        <img src={LogoImage} style={{ width: "100%",maxWidth: "150px",objectFit:"contain" ,marginTop:"10px"}} alt="" />
    </CenteredBox>
}
export default Logo